import { Organization } from '@lucidtech/las-sdk-browser';

import { DEFAULT_TRIAL_DAYS } from '@/constants';
import { toOrganizationId, useGetOrganization } from '@/hooks/api';

const toDaysSinceEpoch = (date: Date) => {
  return date.getTime() / (24 * 60 * 60 * 1000);
};

export const checkOrganizationTrialStatus = (organization?: Organization | null) => {
  if (!organization) {
    return {};
  }

  if (organization.privileges.paymentExempt) {
    return { hasUpgraded: true };
  }

  const trialDays = Number(organization.privileges.trialDays ?? DEFAULT_TRIAL_DAYS);
  const hasUpgraded = Boolean(organization.paymentMethodId && organization?.planId);

  if (hasUpgraded || !organization) {
    return { trialDays, hasUpgraded };
  }

  const daysSinceCreated = Math.floor(toDaysSinceEpoch(new Date()) - toDaysSinceEpoch(organization.createdTime));
  const daysRemaining = Math.max(trialDays - daysSinceCreated, 0);
  const hasExpired = !hasUpgraded && daysRemaining === 0;

  return { daysRemaining, hasUpgraded, trialDays, hasExpired };
};

export const useRemainingDaysOfTrial = () => {
  const { data: organization } = useGetOrganization(toOrganizationId('me'));
  return checkOrganizationTrialStatus(organization);
};
